import { Component, OnInit, ViewChild, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges, ElementRef, HostListener, ViewContainerRef, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';

import { AlertType, NotificationType } from 'base-models';

import { Site, Supervision, IssueType, SupervisionError, SupervisionErrorStatusEnum, SupervisionStatusEnum, InfoIssue, Panel, Flight, IssueImage, SupervConstants, ImageItemTag } from 'solar-bo';

import { IssueListBaseComponent } from './issue-list-base.component';


import { MapSupervisionHelper } from '@solar/ol';
import { ControlEnum } from 'solar-bo';
import { ImageSliderComponent } from '../imageslider/imageslider.component';
import { IssueEdit2Component } from '../issue-edit/issueedit2.component';
import { IIssueEditOptions } from '../issue-edit/iissueeditoptions.interfaces';
import { CtxMenuComponent } from 'basecomponents';
import { ImagePanelChangeOffsetComponent } from './image-change-panel-offset/imagepanelchangeoffset.component';
import { ObjHelper } from 'shtools';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';

interface ValidationsOptions {
  movenext: boolean
}

@Component({
  selector: 'app-ex-issue-list-validator',
  templateUrl: './issue-list-validator.component.html',
  styleUrls: ['./issue-list-validator.component.scss']
})
export class IssueListValidatorComponent extends IssueListBaseComponent implements OnInit, AfterViewInit, OnChanges {

  TAG:string="IssueListValidatorComponent";
  //for html
  supervisionErrorStatusEnum = SupervisionErrorStatusEnum;

  issue: SupervisionError;
  issueOrg: SupervisionError = new SupervisionError();
  issueChanged: boolean = false;

  
  private _issuesData: { issues: SupervisionError[]; issuesFiltered: SupervisionError[]; };
  
  @Input() public get issuesData(): { issues: SupervisionError[]; issuesFiltered: SupervisionError[]; } {
    return this._issuesData;
  }
  public set issuesData(value: { issues: SupervisionError[]; issuesFiltered: SupervisionError[]; }) {
    this._issuesData = value;

  }

  @Input()
  public get issuesFiltered(): SupervisionError[] {
    return this.issues;
  }
  public set issuesFiltered(value: SupervisionError[]) {
    this.configIssueList(value);
  }
  /**
   * Used to control when user is going to change the panel
   */
  issueChangePanelActive: boolean = false;
  /**
   * init change panel so parent component can initialize change
   */
  @Output() issueChangePanelInitiatorEvent: EventEmitter<any> = new EventEmitter();
  focusActive:boolean=true;

  private _options: ValidationsOptions = { movenext: false };
  @Input() get options(): any {
    return this._options;
  }
  set options(value: any) {
    this._options = value;
  }

  issueEditOptions: IIssueEditOptions = { showIssueOnCanvas: true, openimage: true };

  @ViewChild("imageSlider") imageSlider: ImageSliderComponent;

  constructor(
  ) {
    super();
    this.issueEditOptions.showIssueOnCanvas = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_SHOWISSUEONCANVAS);

  }

  ngOnChanges(changes: SimpleChanges) {
    let typeChange = changes['supervision'];
    if (typeChange && typeChange.previousValue == undefined) {
      //this.supervision = typeChange.currentValue;
      if (!this.supervision) {
        return;
      }

      this.site = this.supervision.site;

      if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
        || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
        this.svFilter.filter_status = SupervisionErrorStatusEnum.validated;
        this.uiStatusOpen = false;
      }
    }

/*     typeChange = changes['issues'];
    if (typeChange) {
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"base>> childOnChanges issues");
      this.configIssueList(this.issues);
    } */
  }


  RIGHT_ARROW = 39;
  LEFT_ARROW = 37;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.focusActive==false){
      return;
    }
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,event);

    if (event.ctrlKey == false) {
      if (event.keyCode === this.RIGHT_ARROW) {
        this.itemmove(this.issue, 'NEXT');
      }
      else if (event.keyCode === this.LEFT_ARROW) {
        this.itemmove(this.issue, 'PREV');
      }
    }
    else {
      if (event.keyCode === this.RIGHT_ARROW) {
        this.itemmove(this.issue, 'LAST');
      }
      else if (event.keyCode === this.LEFT_ARROW) {
        this.itemmove(this.issue, 'FIRST');
      }
    }
  }


  configsource(list: any[]) {
    this.filteredList = list;
    this.uiConfigStats();
    if (list && list.length > 0) {
      if (this.issue) {
        //check if the index is the actual 
        let idx = this.issueGetIndexById(this.issue.id);
        if (idx > -1) {
          this.selectRow(idx);
        }
        else {
          this.itemIndex = 0;
          this.selectRow(this.itemIndex);
        }
      }
      else {
        this.itemIndex = 0;
        this.selectRow(this.itemIndex);
      }


      this.issueSelectedEvent.emit(this.issue);
    }
    else{
      this.issue=null;
      this.issueSelectedEvent.emit(this.issue);
    }
  }
  /**
   * overrides base
   */
  uiConfigStats() {
    try {
      this.issuecount = this.issues.length;
      this.issuecheckedcount = this.issues.filter(elem => elem.info.status == SupervisionErrorStatusEnum.validated).length;
      this.issuenoerrorcount = this.issues.filter(elem => elem.info.statusType == SupervisionErrorStatusEnum.noerror).length;
      this.issueRepeatedCount = this.issues.filter(elem => elem.info.issueRepeated == true).length;
      this.issueErrorCountToValidate = this.issuecount - this.issuecheckedcount;
    }
    catch (err) {
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,err, "Error retrieving supervision issues");
    }
  }

  getIssueCount(){
    if (this.issuecount==this.issueTotalCount){
      //No filter applied
      return this.issueTotalCount;
    }else{
      return "Showing " + this.issuecount + " of " + this.issuesOriginal.length;
    }
  }

  /**
   * Return issue url image to draw on canvas background
   * @param issue 
   */
  issue_urlimg(issue: SupervisionError): string {
    //todo: es posible que se pueda mover este metodo directamente dentro del canvas component si tiene todos los campos dentro del issue
    let id_site = this.supervision.site.id;
    let id_supervision = this.supervision.id;
    let id_flight = issue.flight.id;
    let image_name = issue.image.name;
    return MapSupervisionHelper.issueUrlImgByFullFields(image_name, id_site, id_supervision, id_flight);
  }

  filterListByErrorType() {
    let actualIssue = this.issue;
    this.filterChangedEvent.emit(this.svFilter);

    try {
      this.uiConfigStats();
      if (actualIssue) {
        this.selectRowById(actualIssue.id);
      } else {
        this.selectRow(0);
      }
    }
    catch (err) {
      this.handleError(err, "Error retrieving supervision issues");
    }

  }

  itemIndex = 0;
  itemmove(item: SupervisionError, direction?: string) {
    if (this.issueChanged) {
      this.showerror("Sorry, issue was changed, save error or cancel");
      return;
    }
    if (!this.filteredList || this.filteredList.length == 0) {
      return;
    }
    let len = this.filteredList.length;
    let newIndex = 0;
    if (direction === "NEXT") {
      newIndex = this.itemIndex + 1;
      if (len > newIndex) {
        this.itemIndex = newIndex;
        this.selectRow(newIndex);
      }
    }
    else if (direction === "PREV") {
      newIndex = this.itemIndex - 1;
      if (newIndex > -1) {
        this.itemIndex = newIndex;
        this.selectRow(newIndex);
      }
    }
    else if (direction === "FIRST") {
      this.itemIndex = 0;
      this.selectRow(newIndex);
    }
    else if (direction === "LAST") {
      newIndex = len - 1;
      this.itemIndex = newIndex;
      this.selectRow(newIndex);
    }

    this.issueSelectedEvent.emit(this.issue);
  }

  selectRow(index) {
    this.issueChanged = false;
    let issue2Find: SupervisionError = this.filteredList[index];
    if (issue2Find){
      this.issueOrg = issue2Find;
      this.issue = new SupervisionError();
      this.issue = ObjHelper.cloneDeep(issue2Find);
      
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"Issue selected:", issue2Find);      
    }

    this.itemIndex = index;
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"Issue panel:", JSON.stringify(issue.info.panel));
  }


  ui_issueGetstatus(issue: SupervisionError) {
    if (issue && issue.info) {
      return issue.info.status;
    }
  }
  ui_issueGetstatusDesc(): string {
    if (this.issue && this.issue.info) {
      let res = "";
      if (this.issue.info.status == SupervisionErrorStatusEnum.tovalidate) {
        return "UnChecked"
      } else if (this.issue.info.status == SupervisionErrorStatusEnum.validated) {
        return "Checked"
      } else if (this.issue.info.status == SupervisionErrorStatusEnum.tocheck) {
        return "To check"
      }

    }
    return "";
  }

  ui_issueStatusTypeIsError(issue: SupervisionError) {
    if (issue && issue.info) {
      let isRes = issue.info.statusType && issue.info.statusType == SupervisionErrorStatusEnum.noerror;
      return isRes;
    }

    return false;
  }
  ui_issueStatusTypeIsRepeated(issue: SupervisionError) {
    if (issue && issue.info) {
      let isRes = issue.info.issueRepeated;
      return isRes;
    }

    return false;
  }

  issueNoError(issue: SupervisionError) {
    let panelLocator: string = SupervisionError.uiLocator(issue, this.site.info.panel_locator_pattern.list);

    try {
      if (this.issue.info.statusType == SupervisionErrorStatusEnum.noerror){
        this.showNotificationInfo("This issue is marked as no error. If you want to deselect please select issue type.");
        return;
      }
      this.issueChanged = true;
      this.issue.info.errorTypePrev = this.issue.type;
      this.issue.type = IssueType.NDM;
      this.issue.info.statusType = SupervisionErrorStatusEnum.noerror;

      let issueDTOCopy: SupervisionError = this.copyIssue();
      issueDTOCopy.info.status = SupervisionErrorStatusEnum.validated;
      this.saveIssue(issueDTOCopy, this._options);
    }
    catch (err) {
      this.notifyerror(err, "Error saving issue for panel: " + panelLocator);
    }
  }

  issueRepeated(issue: SupervisionError) {
    let panelLocator: string = SupervisionError.uiLocator(issue, this.site.info.panel_locator_pattern.list);

    try {
      this.issueChanged = true;
      this.issue.info.issueRepeated = !this.issue.info.issueRepeated;
    }
    catch (err) {
      this.notifyerror(err, "Error changing issue for panel: " + panelLocator);
    }
  }

  /**
   * user select the error type 
   * @param item 
   * @param newType 
   */
  issueChangeError(item: SupervisionError, newType: IssueType) {
    this.issue.info.errorTypePrev = this.issue.type;
    this.issue.type = newType;
    this.issue.info.statusType = SupervisionErrorStatusEnum.errorchanged;
    if (this.issue.type !== this.issueOrg.type) {
      this.issueChanged = true;
    }
    else {
      this.issueChanged = false;
    }
  }

  private copyIssue() {
    let issueDTOCopy: SupervisionError = new SupervisionError();
    issueDTOCopy.id = this.issue.id;
    issueDTOCopy.type = this.issue.type;
    issueDTOCopy.info = new InfoIssue();

    /*     if (this.issueOrg.info.status == SupervisionErrorStatusEnum.tovalidate) {
          issueDTOCopy.info.status = SupervisionErrorStatusEnum.validated;
        } else {
          issueDTOCopy.info.status = this.row.info.status;
        } */

    issueDTOCopy.info.status = this.issue.info.status;
    issueDTOCopy.info.statusType = this.issue.info.statusType;
    issueDTOCopy.info.issueRepeated = this.issue.info.issueRepeated;
    issueDTOCopy.info.errorTypePrev = this.issue.info.errorTypePrev;

    issueDTOCopy.info.panel = new Panel;
    issueDTOCopy.info.panel.id = this.issue.info.panel.id;

    issueDTOCopy.info.updated_by = this.globService.currentUserValue.id;
    issueDTOCopy.info.validatedby = this.globService.currentUserValue.id;
    issueDTOCopy.info.validation_date = new Date();
    return issueDTOCopy;
  }
  /**
   * Save issue only
   * @param issue 
   */
  saveIssue_click(issue: SupervisionError) {
    let panelLocator: string = SupervisionError.uiLocator(issue, this.site.info.panel_locator_pattern.list);
    try {
      let issueDTOCopy: SupervisionError = this.copyIssue();
      let options: ValidationsOptions = { movenext: false };
      this.saveIssue(issueDTOCopy, options);

    }
    catch (err) {
      this.notifyerror(err, "Error saving issue for panel: " + panelLocator);
    }
  }

  /**
   * used by ui
   * @param issue 
   */
  confirmIssue_click(issue: SupervisionError) {
    let panelLocator: string = SupervisionError.uiLocator(issue, this.site.info.panel_locator_pattern.list);
    try {
      let issueDTOCopy: SupervisionError = this.copyIssue();
      issueDTOCopy.info.status = SupervisionErrorStatusEnum.validated;

      this.saveIssue(issueDTOCopy, this._options);

    }
    catch (err) {
      this.notifyerror(err, "Error saving issue for panel: " + panelLocator);
    }

  }

  /**
   * Cancel changes on issue and set original values
   * @param row 
   */
  issueCancelChange(row) {
    let actuallocator = this.issue.info.panel.locator;
    if (!Panel.locatorIsEqual(actuallocator, this.issueOrg.info.panel.locator)) {
      this.issueChangePanelActive = false;
      let event = { issue: row, status: "RESTORE", issueOrig: this.issueOrg };
      this.issueChangePanelInitiatorEvent.emit(event);
    }

    this.issue = new SupervisionError();
    this.issue = ObjHelper.cloneDeep(this.issueOrg);

    //row.type = this.issueOrg.type;
    //row.info.status = this.issueOrg.info.status;
    //row.info.panel = this.issueOrg.info.panel;
    this.issueChanged = false;
    this.alertmessage = null;
  }

  saveIssue(issueDTOCopy: SupervisionError, options: ValidationsOptions) {
    this.listerrmessage = "";
    this.alertmessage = null;
    this.loading = true;
    this.issueChangePanelActive = false;
    let event = { issue: this.issue, status: "CANCEL" };
    this.issueChangePanelInitiatorEvent.emit(event);

    this.solarService.supervisionIssueUpdate(issueDTOCopy)
      .subscribe(
        resIssueSaved => this.saveIssueHandleresult(issueDTOCopy, this.issue, resIssueSaved, options)
        , err => this.saveIssueHandleError(err)
      );
  }

  saveIssueHandleError<T>(err: any) {
    this.loading = false;
    this.handleError(err, "Error updating issue ");
  }

  saveIssueHandleresult(issueDTO: SupervisionError, issue: SupervisionError, issueSaved: SupervisionError, options: ValidationsOptions) {
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,'getListhandleresult', issueSaved);
    this.listerrmessage = '';
    //this.alertmessage = null;
    this.loading = false;
    this.issueChanged = false;
    //check wich fields must be filled by server or by app
    issueSaved.info.panel = issue.info.panel; //filled by reference

    this.issueOrg.type = issueSaved.type;
    this.issueOrg.info = issueSaved.info;

    issue = ObjHelper.cloneDeep(this.issueOrg);
    this.issue = issue;
    //actualizar lista de datos en funcion del filtro???
    //this.filterChangedEvent.emit(this.svFilter);
    this.uiConfigStats();
    this.dataChange.next(issue);
    
    this.issueSelectedEvent.emit(this.issue);
    this.componentEvent.emit({ eventName: "ISSUE_SAVED", value: issue });
    this.showNotification(NotificationType.Success, "Issue saved: " + issue.info.panel.name);
    if (options && options.movenext) {
      this.itemmove(issue, 'NEXT');
    }
    this.saveSupervision();

  }
  /**
   * Save supervision lastupdate date only
   * @param value 
   */
  private saveSupervision(value?: any) {
    try {
      
      //const clonemodel = {id:this.supervision.id, err: this.supervision.info.errorsDetected};
      const clonemodel =new Supervision();
      clonemodel.id=this.supervision.id;
      clonemodel.info.errorsDetected=this.issuesOriginal.length;
      this.solarService.supervisionUpdateSimple(clonemodel)
        .subscribe((resmodel) => this.supervision.info.updating_date= resmodel.info.updating_date
          , err => DBG.log(DebugLevelEnum.VERBOSE,this.TAG,err)
        );
    } catch (error) {
     
      console.error(error);
    }
  }



  issueChangePanel(row: SupervisionError, action: boolean) {

    if (!action) {
      this.issueChangePanelActive = false;
      let event = { issue: row, status: "CANCEL" };
      this.issueChangePanelInitiatorEvent.emit(event);
      //cambiar botones, etc
    }
    else if (action) {
      this.issueChangePanelActive = true;
      let event = { issue: row, status: "START" };
      this.issueChangePanelInitiatorEvent.emit(event);
      //cambiar botones, etc
    }
  }
  //called by parent
  /**
   * change selected issue panel by new one
   * @param newPanel 
   */
  public changePanel(newPanel:Panel) {
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"changePanel------------------------sELECTED", newPanel);
    if (this.issueChangePanelActive) {
      if (this.issue.info.panel.id!= newPanel.id) {
        this.issue.info.panel = newPanel;
        this.issueChanged = true;
        let event = { issue: this.issue, status: "CHANGED" };
        this.issueChangePanelInitiatorEvent.emit(event);
        this.issueChangePanelActive = false;
      }
    }
  }

    /**
   * message to show to user when no panel is found by panel locator component
   */
  panelMessage: string = "";
  panellocator_panelChangeEvent_handler($event) {
    let newPanel = $event;
    if (newPanel===undefined){
      this.issue.info.panel = newPanel;

      return;
    }
    if (newPanel && this.issue.info.panel.id!= newPanel.id) {
      this.issue.info.panel = newPanel;
      this.issueChanged = true;
      let event = { issue: this.issue, status: "CHANGED" };
      this.issueChangePanelInitiatorEvent.emit(event);
      this.issueChangePanelActive = false;
    }
    //this.configureInfoExist(this.issue);
  }

  flightShowEvent($event) {

  }

  isvalid(){
    if (this.issue.info.panel ==null){
      return false;
    }
    return true;
  }

  changeStatus_click(value: SupervisionErrorStatusEnum) {
    if (!this.issue) {
      return;
    }
    if (this.issue.info.status != value) {
      this.issue.info.status = value;

      this.issueChanged = this.checkIfChanged();
    }
  }
  ui_showEditStatus() {

    let verifyChange: boolean = this.checkIfChanged();
    if (!verifyChange) {
      return "";
    }

    let msg = "";

    if (this.issueOrg.info.panel.id !== this.issue.info.panel.id) {
      msg += " <b>Panel changed:</b> Previous panel " + SupervisionError.uiLocator(this.issueOrg, this.site.info.panel_locator_pattern.list);
    }
    if (this.issueOrg.info.status !== this.issue.info.status) {
      if (this.issue.info.status == SupervisionErrorStatusEnum.validated) {
        msg += " Issue marked as <b>Checked</b>.";
      } else if (this.issue.info.status == SupervisionErrorStatusEnum.tovalidate) {
        msg += " Issue marked as <b>UnChecked</b>.";

      }
    }
    if (this.issueOrg.info.statusType !== this.issue.info.statusType) {

      if (this.issue.info.statusType == SupervisionErrorStatusEnum.noerror) {
        msg += " Issue marked as <b>No Error</b>.";
      }
      else if (this.issue.info.statusType == SupervisionErrorStatusEnum.errorchanged) {
        msg += " Previous error: " + this.ui_errortype(this.issueOrg);
      }
    }
    if (this.issueOrg.info.issueRepeated !== this.issue.info.issueRepeated) {

      if (this.issue.info.issueRepeated) {
        msg += " Issue marked as <b>Repeated</b>.";
      }
      else {
        msg += " Issue marked as <b>No Repeated</b>.";
      }
    }



    return msg;
  }

  checkIfChanged() {
    if (this.issueOrg.info.status !== this.issue.info.status) {
      return true;
    }
    if (this.issueOrg.info.panel.id !== this.issue.info.panel.id) {
      return true;
    }
    if (this.issueOrg.info.statusType !== this.issue.info.statusType) {
      return true;
    }
    if (this.issueOrg.info.issueRepeated !== this.issue.info.issueRepeated) {
      return true;
    }

    return false;
  }

  ui_btn_statustype_class(issue: SupervisionError, statusType: SupervisionErrorStatusEnum) {
    if (!issue) {
      return "";
    }
    if (issue.info.statusType === statusType) {
      return "btn-primary text-white";
    }
  }
  ui_btn_repeated_class(issue: SupervisionError): string {
    if (!issue) {
      return "";
    }
    if (issue.info.issueRepeated == true) {
      return "btn-primary text-white";
    }
  }


  newIssue(): SupervisionError {
    try {
      let n: SupervisionError = new SupervisionError();
      n.created_by = this.globService.currentUserValue.id;
      //let fkSupervision=new Supervision();
      //fkSupervision.id=this.supervision.id;
      //fkSupervision.site=new Site();
      //fkSupervision.site.id=this.site.id;
      //n.supervision=fkSupervision;
      n.supervision = this.supervision;

      n.type = IssueType.E1PC;
      /*       if (this.row){
              n.flight=this.row.flight;
              n.image=this.row.image;        
            } */
      //this.issues.push(n);
      // this.drawPanelSelected(this.issueSelected);
      //this.showNotificationInfo("New Issue added to issue list. Now you need to select the panel and an image.");
      return n;
    }
    catch (err) {
      this.showNotificationError("Error creating issue", err);
    }
  }

  thumbOnRightClick($event) {

    let index: number = $event;
    let imgData = this.imageSlider.getImage(index);
    DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"onRightClick", $event, imgData);
    let dto:{flight:Flight,image:IssueImage, gallery:any}={flight:imgData.tag.flight,image:imgData.tag.image, gallery:this.imageSlider.galleryImagesStore};
    this.addNewIssueFromImage(dto);

    return false;
  }

  public addNewIssueFromImage(extraData:{flight:Flight,image:IssueImage, gallery:any}) {
    let newIssue = this.newIssue();
    newIssue.flight = extraData.flight;
    newIssue.image = extraData.image;

    let options = { showIssueOnCanvas: true, openimage: false };
    let ref: MatDialogRef<IssueEdit2Component> = IssueEdit2Component.openModal(this.dialog, newIssue, this.supervision, options);
    ref.componentInstance.issueList = this.issues;
    ref.componentInstance.flight = extraData.flight;
    ref.componentInstance.image = extraData.image;
    ref.componentInstance.gallery = extraData.gallery;

    this.focusActive=false;
    ref.componentInstance.configComponent() ;
    ref.componentInstance.issueSavedEvent.subscribe(issue => this.addNewIssueFromImageHandler(issue));
    ref.componentInstance.imageChangeEvent.subscribe(image => this.issueEditComponent_imageChangeEventHandler(image));
    ref.afterClosed().subscribe(dlg=>this.focusActive=true);
  }

  private issueEditComponent_imageChangeEventHandler(image:ImageItemTag){
    this.componentEvent.next({eventName:SupervConstants.ISSUE_EDIT_IMAGE_CHANGE,value:image});
  }

  private addNewIssueFromImageHandler(newIssue: SupervisionError) {
    //for precaution we assign this data
    newIssue.supervision = this.supervision;
    let existIssue: SupervisionError = null; // siempre creamos this.issues.find(elem => elem.info.panel.id === newIssue.info.panel.id);
    
    if (existIssue) {
      //por aqui no entra, segun requerimientos siempre se crea un nuevo issue y se deja la responsabilidad al usuario
      //to avoid changes by reference in map we need to assign some elements
      existIssue.info = newIssue.info;
      existIssue.image = newIssue.image;
      existIssue.flight = newIssue.flight;
      existIssue.type = newIssue.type;
      this.selectRowById(existIssue.id);
    }
    else {

      //add panel to collection and map
      this.componentEvent.emit({ eventName: SupervConstants.ISSUE_ADDED, value: newIssue });
      //this.issuesOriginal.push(newIssue); added in parent by event
      //this.issues.push(newIssue); added in parent by event
      this.uiConfigStats();      
      this.issue=newIssue;
      //this.selectRowById(newIssue.id);

    }

    this.issueSelectedEvent.emit(this.issue);
  }

  showErrorAll() {
    this.svFilter.filter_status = SupervisionErrorStatusEnum.none;
    this.svFilter.filter_status_type = SupervisionErrorStatusEnum.noerror;
    this.svFilter.show_issueRepeated = true;
    this.filterListByErrorType();
  }

  showErrorUnValidated() {
    this.svFilter.filter_status = SupervisionErrorStatusEnum.tovalidate;
    this.filterListByErrorType();
  }
  showErrorValidated() {
    this.svFilter.filter_status = SupervisionErrorStatusEnum.validated;
    this.filterListByErrorType();
  }
  showErrorNot() {
    if (this.svFilter.filter_status_type == SupervisionErrorStatusEnum.noerror) {
      this.svFilter.filter_status_type = null;
    } else {
      this.svFilter.filter_status_type = SupervisionErrorStatusEnum.noerror;
    }

    this.filterListByErrorType();
  }
  showRepeated() {
    if (this.svFilter.show_issueRepeated == true) {
      this.svFilter.show_issueRepeated = null;
    } else {
      this.svFilter.show_issueRepeated = true;
    }

    this.filterListByErrorType();
  }

  @ViewChild("ctxmenu") ctxmenucomp: CtxMenuComponent;
  issueviewHandler($event) {
    

    //item.actions.push( { description: 'Remove image'        ,action: this.ctx_test });
    let event2Send: any;
    if ($event.type == "CANVAS_RIGHT_CLICK") {
      let index: number = $event.index;
      let item: any = { index: index, actions: [] };
      item.actions.push({ description: 'New issue from image', action: this.canvas_context_menu_newIssue.bind(this) });
      item.actions.push({ description: 'Change offset for panels', action: this.changeImagePanelOffset.bind(this) });
      event2Send = $event.event.event;
      this.ctxmenucomp.ctx_open(event2Send, item);
    }else if ($event.type == "ADD_ISSUE_FROM_IMAGE") {
      let dto:{flight:Flight,image:IssueImage, gallery:any}={flight:this.issue.flight, image:this.issue.image, gallery:this.imageSlider.galleryImagesStore};     
      this.addNewIssueFromImage(dto);
      return;
    }

    return false;//to avoid show context
  }

  canvas_context_menu_newIssue($event){
    try {
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,$event);
      this.ctxmenucomp.ctx_close(); 
      let dto:{flight:Flight,image:IssueImage, gallery:any}={flight:this.issue.flight, image:this.issue.image, gallery:this.imageSlider.galleryImagesStore};     
      this.addNewIssueFromImage(dto);

    }
    catch (err) {

    }
  }

  changeImagePanelOffset($event) {
    try {
      DBG.log(DebugLevelEnum.VERBOSE,this.TAG,$event);
      this.ctxmenucomp.ctx_close();
      let ref: MatDialogRef<ImagePanelChangeOffsetComponent> = ImagePanelChangeOffsetComponent.openModalWithModel(this.dialog, this.issue);
      ref.componentInstance.saveEvent.subscribe(res => this.changeImagePanelOffset_handleResult([res]))
      //abrir dialogo para seleccionar offset
      /*
      params:
      id supervision
      id_image
      offset x
      offset y

      devuelve lista de issues con id_issue y id_panel
      */
      //return false;//to avoid show context
    }
    catch (err) {

    }
  }
  async changeImagePanelOffset_handleResult(res:{id_issue:string,id_panel:string}[]){
    let sitePanelsp=await this.solarService.solarCacheSvc.sitePanelsById(this.site.id);
    let sitePanels:any[]=sitePanelsp;
    for(let ch of res){
      let issue:SupervisionError= this.issuesOriginal.find(elem=>elem.id==ch.id_issue);
      let newPanel:Panel=sitePanels.find(elem=>elem.id==ch.id_panel);

      if (issue && newPanel){
        //lo anterior se tiene que cumplir siempre, de lo contrario 
        //hay un error en el servidor o un cambio que la app no tiene registrado y se tendria que buscar esa informacion en el servidor directamente
        let oldPanel=issue.info.panel;
        //this.validatorEvent.emit({ eventName: SupervConstants.ISSUE_PANEL_REMOVE, value: issue });
        //asignar nuevo panel
        issue.info.panel=newPanel;
        this.componentEvent.emit({ eventName: SupervConstants.ISSUE_PANEL_MODIFIED, value: issue });
        if (this.issue.id==issue.id){
          this.issue.info.panel=newPanel;
          this.issueSelectedEvent.emit(this.issue);
        }
        
        //actualizar canvas???

      }
    }
    //por cada issue buscamos el issue y le asignamos el panel. 
    /**
     * borrar paneles afectados
     * Redibujar paneles en el sistema
     */

  }

}


